







































import { Component, Vue, Prop, Inject } from 'vue-property-decorator'

@Component
export default class PromotionSeckill extends Vue {
  @Prop({ default: () => {} }) readonly panicbuy!: any
  @Prop({ default: () => {} }) readonly choice!: any

  @Inject({ from: 'toPanicBuyEP', default: null }) toPanicBuyEP!: any
  get toPanicBuyExposure() {
    const { spuId = '' } = this.firstPanic
    return this.toPanicBuyEP && this.toPanicBuyEP({spuid: spuId})
  }
  toPanicBuy() {
    const { spuId = '' } = this.firstPanic
    this.$emit('toPanicBuy',spuId)
    this.$router.push({ name: 'panicbuy', query: { spuId } })
  }

  @Inject({ from: 'toChoiceEP', default: null }) toChoiceEP!: any
  get toChoiceExposure() {
    const { spuId = '' } = this.firstPanic
    return this.toChoiceEP && this.toChoiceEP({spuid: spuId})
  }
  toChoice() {
    const { spuId = '' } = this.firstChoice
    this.$emit('toChoice',spuId)
    this.$router.push({ name: 'choice', query: { spuId } })
  }
  get firstPanic() {
    if (this.panicbuy.promotionList && this.panicbuy.promotionList.length > 0) {
      return this.panicbuy.promotionList[0]
    }
    return {}
  }

  get firstChoice() {
    if (this.choice.promotionList && this.choice.promotionList.length > 0) {
      return this.choice.promotionList[0]
    }
    return {}
  }
}
